/* eslint-disable */
import axios from "axios";

const apiClient = axios.create({
    baseURL: "http://localhost:3000",
    withCredentials: false,
    headers:{
        Accept: "Application/json",
        "Content-Type": "application/json"
    }
});


export default {

    getLanguage(moduleName, country, lang){
        return apiClient.get("https://www.discover-shiseido.com/Module/i18n/"+moduleName, {
            params:{
                country: country,
                lang: lang
            }
        })
    }

}


